import Trans from 'components/Trans'

const config = [
  {
    title: <Trans>How much is the participation fee?</Trans>,
    description: [<Trans>The fee will be the price of open blind box.</Trans>],
  },
  {
    title: <Trans>Where does the participation fee go?</Trans>,
    description: [<Trans>The token from the participation fee will be transfer to foundation.</Trans>],
  },
]
export default config
